import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useGetReportQuery } from "../../utils/api/endpoints/reportsApi";
import { ReportStatus, ReportState } from "../../utils/api/endpoints/reports/reports";
import ReportEditor from "../../pages/reports/ReportEditor";
import LoadingSpinner from "../retests/utils/LoadingSpinner";
import ErrorPage from "../../pages/ErrorPage";

/**
 * Route guard component that only allows QA users to edit reports
 * when the report status is DRAFT or state is UNDER_REVIEW
 */
const QAReportEditGuard: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const reportId = id ? parseInt(id) : undefined;

  const { data: reportData, isLoading, error } = useGetReportQuery(reportId!, {
    skip: !reportId
  });

  // Show loading spinner while fetching report data
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Show error page if report fetch failed or report not found
  if (error || !reportData) {
    return <ErrorPage />;
  }

  // Check if QA user has permission to edit this report
  const canEdit = 
    reportData.status === ReportStatus.DRAFT || 
    reportData.state === ReportState.UNDER_REVIEW;

  // If QA doesn't have permission, redirect to report view page
  if (!canEdit) {
    return <Navigate to={`/dashboard/reports/${id}`} replace />;
  }

  // If all checks pass, render the ReportEditor
  return <ReportEditor />;
};

export default QAReportEditGuard;
